<template>
  <v-card>
    <ac-data-table
      :headers="headers"
      :items.sync="items"
      :item-class="row_class"
      sort-by="name"
      item-key="uid"
      hide-default-footer
      disable-pagination
      fixed-header
      :height="winsize.height - 145"

      :search.sync="search"
      :show-bulk="false"

      title="Product Group"
    >

      <template v-slot:item.enabled="{item}">
        <div align="center">{{ item.enabled ? "ON" : "OFF" }}</div>
      </template>
      <template v-slot:item.oneRow="{item}">
        <div align="center">{{ item.oneRow == 1 ? "ON" : "OFF" }}</div>
      </template>
      <template v-slot:item.actions="{item}">
        <v-icon v-if="row_readonly(item)" @click="row_view(item)" class="mr-2" small color="green">
          mdi-eye
        </v-icon>
        <v-icon v-else-if="item.locked" @click="row_update(item)" class="mr-2" small color="orange">
          mdi-pencil
        </v-icon>
        <v-icon v-else @click="row_update(item)" class="mr-2" small color="green">
          mdi-pencil
        </v-icon>
        <v-icon :disabled="item.global || item.shared" @click="row_export(item)" class="mr-2" small color="blue">mdi-briefcase-upload
        </v-icon>
        <v-icon :disabled="item.global || item.shared" @click="row_convert(item)" class="mr-2" small color="blue">
          mdi-cloud-upload-outline
        </v-icon>
      </template>
      <template v-slot:no-results>
        <v-alert :value="true" color="blue-grey" dense>
          Your search for "{{ search }}" found no results.
        </v-alert>
      </template>
    </ac-data-table>
    <r-product-group-dialog ref="dialog"/>
  </v-card>
</template>

<script>
import VueTypes from "vue-types";
import {ViewRules} from "@/common/ViewRules";

import {RedactorUtils} from "@/modules/redactor/core/RedactorUtils";
import {ProductGroup} from "@/modules/redactor/models/product/ProductGroup";
import RProductGroupDialog from "@/modules/redactor/views/product-group/r-product-group-dialog.vue";
import AcDataTable from "@/components/Table/ac-data-table.vue";


export default {
  name: "r-product-group-page",
  components: {AcDataTable, RProductGroupDialog},
  data: () => ({
    search: "",
    headers: [
      {text: "Kind", value: "kind.name"},
      {text: "Order", value: "order"},
      {text: "Reset Time", value: "resetTime"},
      {text: "In One Row", value: "oneRow"},
      {text: "Status", value: "enabled"},
      {text: '', value: 'actions', width: '100%', sortable: false, align: 'end'}
    ],
    items: {
      type: VueTypes.arrayOf(ProductGroup)
    },
  }),
  computed: {
    winsize() {
      return window.app.winsize;
    }
  },
  methods: {
    row_view(item) {
      this.$refs['dialog'].show(ViewRules.READONLY, item.clone()).catch(() => {

      });
    },
    row_update(item) {
      this.$refs['dialog'].show(ViewRules.UPDATE, item.clone()).then(
        result => {
          RedactorUtils.pushProductGroup(result).then(
            () => {
              this.$alert("Changes was published");
            });
        }, () => {
        });
    },
    row_convert(item) {
      this.$confirm("Are you sure you want to move this item to global config?")
        .then(() => {
          RedactorUtils.convertProductGroup(item.clone())
            .then(() => {
              this.$alert("Changes was published", "Convert To Global", "success");
            })
            .catch((error) => {
              this.$alert(error, "Convert To Global", "error");
            });
        });
    },
    row_export(item) {
      let result = item.clone();
      result.export = !item.export;
      RedactorUtils.pushProductGroup(result);
    },
    row_class(item) {
      if (item.shared) {
        return "yellow lighten-4"
      } else if (item.global) {
        return "cyan lighten-4"
      } else if (item.export) {
        return "green lighten-3"
      } else if (item.changed) {
        return "blue lighten-3"
      } else if (!item.enabled) {
        return "blue-grey lighten-3"
      }
    },
    row_readonly(item) {
      return (item.locked && !this.masterAccess) || item.global || item.shared;
    }
  },
  created() {
    this.items = RedactorUtils.getProductGroups();
  }
}
</script>